<script lang="ts">
	import { dev } from '$app/environment';
	import { page } from '$app/stores';
	import DesktopIcon from '$lib/components/icons/desktop-icon.svelte';
	import DiscordIcon from '$lib/components/icons/discord-icon.svelte';
	import { Button } from '$lib/components/ui/button';
	import { Container } from '$lib/components/ui/container';
	import { Input } from '$lib/components/ui/input';
	import { cn } from '$lib/utils';
	import { ArrowLeftIcon, ArrowUpIcon, CheckIcon, Loader2Icon } from 'lucide-svelte';
	import mixpanel from 'mixpanel-browser';
</script>

<Container>
	<div
		class="mx-auto grid h-auto w-full grid-cols-1 items-start justify-between gap-6 lg:my-12 lg:grid-cols-2 lg:gap-6"
	>
		<div class="relative col-span-1 flex flex-col items-center justify-center gap-3 lg:items-start">
			<enhanced:img
				src="/static/images/star_full.png"
				alt="img"
				class="absolute left-4 top-36 h-3 w-3"
			/>
			<enhanced:img
				src="/static/images/star_full.png"
				alt="img"
				class="absolute left-16 top-96 mt-12 h-4 w-4"
			/>
			<enhanced:img
				src="/static/images/star_full.png"
				alt="img"
				class="absolute left-80 top-80 mt-12 h-5 w-5"
			/>
			<h3 class="text-center lg:text-left">
				Always <span class="text-primary">On</span>, Always <span class="text-primary">Ready</span>
			</h3>
			<p class="max-w-md text-center font-light text-lightTertiary lg:text-left">
				We have officially turned off the Meeko Discord Bot, Meeko Desktop App and Meeko is now shut
				down for the time being. We truly hope to pick this project up again in the future when the
				conditions are different, but until then, it will be offline.
			</p>
			<p class="max-w-md text-center font-light text-lightTertiary lg:text-left">
				Thank you for everyone who supported us, tried it out and loved the project, we will never
				forget you!
			</p>
			<p class="max-w-md text-center font-light text-lightTertiary lg:text-left">
				<span class="font-normal text-primary">- Much love from the Meeko team</span>
			</p>
		</div>
		<div class="col-span-1 flex flex-col gap-4">
			<div
				class="group relative flex h-36 w-full flex-col gap-3 overflow-hidden rounded-lg border border-discord bg-discord p-10 shadow-lg transition-all hover:border-discord hover:bg-discord"
			>
				<div class="-z-1 absolute bottom-0 right-0">
					<DiscordIcon
						class="h-24 fill-gray-50/10 transition-all ease-in-out group-hover:h-36 sm:h-24"
					/>
				</div>
				<div class="-z-1 absolute bottom-0 right-0">
					<DiscordIcon
						class="h-20 fill-gray-50/10 transition-all ease-in-out group-hover:h-32 sm:h-24"
					/>
				</div>
				<div class="-z-1 absolute bottom-0 right-0">
					<DiscordIcon
						class="h-16 fill-lightPrimary transition-all ease-in-out group-hover:h-28 group-hover:fill-lightPrimary sm:h-24 sm:fill-lightPrimary"
					/>
				</div>
				<span class="text-2xl text-lightPrimary">Discord Bot</span>
				<span class="text-sm font-light text-lightPrimary">Inactive</span>
			</div>
			<div
				class="group relative flex h-36 w-full flex-col gap-3 overflow-hidden rounded-lg border border-purple-500 bg-purple-600 p-10 shadow-lg transition-colors"
			>
				<div class="-z-1 absolute bottom-0 right-0">
					<DesktopIcon class="h-24 fill-gray-50/10 transition-all ease-in-out group-hover:h-36" />
				</div>
				<div class="-z-1 absolute bottom-0 right-0">
					<DesktopIcon class="h-24 fill-gray-50/10 transition-all ease-in-out group-hover:h-32" />
				</div>
				<div class="-z-1 absolute bottom-0 right-0">
					<DesktopIcon
						class="h-24 fill-lightPrimary transition-all ease-in-out group-hover:h-28 group-hover:fill-lightPrimary sm:fill-darkTertiary"
					/>
				</div>
				<span class="text-2xl text-lightPrimary">Desktop App</span>
				<span class="text-sm font-light text-lightPrimary">Inactive</span>
			</div>
			<div
				class="group relative flex h-36 w-full flex-col gap-3 overflow-hidden rounded-lg border border-darkTertiary bg-darkSecondary p-10 shadow-lg transition-colors hover:border-darkQuaternary"
			>
				<div class="-z-1 absolute bottom-0 right-0">
					<DesktopIcon class="h-24 fill-gray-50/10 transition-all ease-in-out group-hover:h-36" />
				</div>
				<div class="-z-1 absolute bottom-0 right-0">
					<DesktopIcon class="h-24 fill-gray-50/10 transition-all ease-in-out group-hover:h-32" />
				</div>
				<div class="-z-1 absolute bottom-0 right-0">
					<DesktopIcon
						class="h-24 fill-lightPrimary transition-all ease-in-out group-hover:h-28 group-hover:fill-lightPrimary sm:fill-darkTertiary"
					/>
				</div>
				<span class="text-2xl text-lightQuaternary">Game Overlay</span>
			</div>
		</div>
	</div></Container
>
